export const normalizeFileName = (fileName: string): string => {
    // Separar nome e extensão
    const lastDotIndex = fileName.lastIndexOf('.');
    const name = lastDotIndex > 0 ? fileName.substring(0, lastDotIndex) : fileName;
    const extension = lastDotIndex > 0 ? fileName.substring(lastDotIndex) : '';

    // Normalizar o nome
    const normalizedName = name
        // Normalizar Unicode (decomposição)
        .normalize('NFD')
        // Remover diacríticos/acentos
        .replace(/[\u0300-\u036f]/g, '')
        // Converter para minúsculo
        .toLowerCase()
        // Substituir espaços por hífens
        .replace(/\s+/g, '-')
        // Remover caracteres especiais, manter apenas letras, números, hífens e underscores
        .replace(/[^a-z0-9\-_]/g, '')
        // Remover hífens consecutivos
        .replace(/-+/g, '-')
        // Remover hífens do início e fim
        .replace(/(^-+|-+$)/g, '');

    return normalizedName + extension.toLowerCase();
};